<template>
    <div class="catalog-mobile">
        <div class="toolbar">
            <a-space>
                <a-select v-model:value="requestPayload.catalog" placeholder="类型" :options="cOptions" @change="getdata"
                    :dropdownMatchSelectWidth="false" allowClear>

                    <template #suffixIcon>
                        <img src="@/assets/img/mobile/page/brand-arrow.png" class="brand-arrow" />
                    </template>
                </a-select>

                <a-select v-model:value="requestPayload.product" placeholder="产品" :options="pOptions"
                    :dropdownMatchSelectWidth="false" @change="getdata" allowClear>
                    <template #suffixIcon>
                        <img src="@/assets/img/mobile/page/brand-arrow.png" class="brand-arrow" />
                    </template>
                </a-select>
            </a-space>
        </div>

        <div class="wrapper-card-list">
            <template v-for="(item) in tableData" :key="item.id">
                <div class="df wrapper-card" :class="item.catalog.indexOf('视光') !== -1 ? 'wrapper-optometry' : ''"
                    @click="toDetails(item)">

                    <div class="wrapper-info">
                        <div class="df vertical">
                            <span class="model" :class="item.catalog.indexOf('视光') !== -1 ? 'model-optometry' : ''">{{
                                sModel(item) }}</span>
                            <span class="catalog" :class="item.catalog.indexOf('视光') !== -1 ? 'catalog-optometry' : ''">
                                {{ sCatalog(item.catalog) }} </span>
                        </div>

                        <!-- <div class="slogan" :class="item.catalog.indexOf('视光') !== -1 ? 'slogan-optometry' : ''">
                            {{ slogan(item.product) }}
                        </div> -->
                    </div>

                    <div class="wrapper-picture">
                        <img src="" alt="">
                    </div>

                </div>
            </template>
        </div>
    </div>

</template>

<script>
import { defineComponent, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { getProductInfoList } from '@/request/view/productPublicityDept.js';
import { catalogOptions, aboutProductOptions } from '../Literature/data';
import { getCopyLink } from '../Literature/data';
import options from '@/components/cascader/option.js';

export default defineComponent({
    setup() {
        const router = useRouter();

        const cOptions = [
            {
                label: '全部',
                value: null,
            },
            ...catalogOptions,
            {
                label: '相关信息',
                value: '相关信息',
            }
        ];

        const pOptions = [
            ...aboutProductOptions,
            ...options.machineOptions,
        ]

        const requestPayload = reactive({
            catalog: null,
            model: null,
            product: null,
        });

        const tableData = reactive([]);

        const getdata = () => {
            tableData.length = 0;
            getProductInfoList(requestPayload).then((res) => {
                if (res.code === 200 && res.message === '成功' && res.data) {
                    const list = res.data.filter((f) => f.isDeactivate === false);
                    tableData.push(...list);
                }
            });
        };

        onMounted(() => {
            document.title = '产品目录';
        });

        const sModel = (item) => {
            let text = item.model
            if (item.product.indexOf('Swan') !== -1) text = item.model.replace('Swan', '天鹅').replace('TE', '天鹅');
            if (item.product.indexOf('columba') !== -1) text = item.model.replace('columba', '天鸽');
            if (item.product.indexOf('tableLamp') !== -1) text = '春晖台灯';
            if (item.product.indexOf('Starton') !== -1) text = item.model.replace('Starton', '星豚');
            if (item.product.indexOf('LanW') !== -1) text = '蓝鲸';
            return text;
        };

        const slogan = (product) => {
            let text = '';
            if (product.indexOf('Swan') !== -1) text = '1s快速精准测量 创新音画吸引系统';

            if (product.indexOf('columba') !== -1) text = '0.4s极速筛查创新音画吸引系统';

            return text;
        };

        const shareText = (text, url) => {
            // 如果浏览器支持 `navigator.share`，则使用该API
            if (navigator.share) {
                navigator.share({
                    text: text,
                    url: url
                })
                    .then(() => console.log('分享成功'))
                    .catch(error => console.error('分享出错：', error));
            }
        }

        const sCatalog = (catalog) => catalog.slice(0, 2);

        getdata();

        const toDetails = (record) => {

            const { catalog, product, model, id } = record;
            router.push({
                path: `/branddetails`,
                query: {
                    id
                }
            });
        };

        return {
            tableData,
            requestPayload,
            pOptions,
            cOptions,
            options,
            toDetails,
            sModel,
            getdata,
            slogan,
            sCatalog,
        };
    }
});
</script>

<style lang="less" scoped>
.catalog-mobile {
    width: 100vw;
    height: 100vh;
    padding: 0.77rem 0.31rem 0.31rem 0.31rem;
    background: #F7F8FB;

    .toolbar {
        height: 60px;
        padding-bottom: 48px;

        :deep(.ant-select-selector) {
            padding: 0 0.31rem 0 0.41rem;
            height: 0.97rem;
            background: #FFFFFF;
            box-shadow: 0rem 0.1rem 0.1rem 0rem #F0F4F9;
            border-radius: 0.49rem;
            border: 1px solid #fff;
            display: flex;
            align-items: center;
        }

        .brand-arrow {
            width: 0.46rem;
            height: 0.46rem;
            margin-top: -8px;
        }
    }

    .wrapper-card-list {
        height: calc(100vh - 135px);
        overflow-y: scroll;

        .wrapper-card {
            width: 9rem;
            height: 2.31rem;
            border-radius: 0.15rem;
            background-color: #fff;
            margin: 0 auto 0.31rem;

            .wrapper-info {
                padding: 0.76rem 0.78rem 0 0.44rem;

                .model {
                    font-weight: bold;
                    font-size: 0.54rem;
                    color: #35B7AD;
                    line-height: 0.81rem;
                    text-shadow: 0px 0px 0px rgba(21, 34, 189, 0.5);
                    margin-right: 0.2rem;
                    white-space: nowrap;

                }

                .model-optometry {
                    color: #FFFFFF;
                    text-shadow: 0px 0px 0px rgba(21, 34, 189, 0.5);
                }

                .catalog {
                    display: inline-block;
                    width: 0.8rem;
                    height: 0.37rem;
                    background: #999999;
                    border-radius: 0.22rem;
                    border: 0.02rem solid #999999;
                    font-weight: bold;
                    font-size: 0.25rem;
                    color: #FFFFFF;
                    text-align: center;
                    margin-left: 0.13rem;
                }

                .catalog-optometry {
                    background: #FFE148;
                    color: #02C4C8;
                    border: 0.01rem solid #F3D57B;
                }

                .slogan {
                    font-size: 0.31rem;
                    color: #999999;
                    line-height: 0.41rem;
                    text-align: left;
                }

                .slogan-optometry {
                    color: #FFFFFF;
                }
            }

            .wrapper-picture {
                width: 2.42rem;
                height: 2rem;
                margin-top: 0.23rem
            }

        }

        .wrapper-optometry {
            background-image: url('../../../assets/img/mobile/page/catalog-optometry.png');
            background-size: 100% 100%;
        }
    }
}
</style>
